import { format, isToday, isTomorrow, isYesterday, parseISO, differenceInMinutes } from "date-fns";
import { it } from "date-fns/locale";

export const TEMPERATURES = {
  poco_caldo: { key: "poco_caldo", label: "Poco caldo", emoji: "🔵", color: "#3B82F6", badge: "bg-blue-500 text-white border-transparent", dot: "bg-blue-500" },
  medio: { key: "medio", label: "Medio", emoji: "🟠", color: "#F97316", badge: "bg-orange-500 text-white border-transparent", dot: "bg-orange-500" },
  caldissimo: { key: "caldissimo", label: "Caldissimo", emoji: "🔥", color: "#EF4444", badge: "bg-red-500 text-white border-transparent", dot: "bg-red-500" },
  perso: { key: "perso", label: "Non interessato / Perso", emoji: "⚫", color: "#09090B", badge: "bg-zinc-900 text-white border border-zinc-600", dot: "bg-zinc-800" },
};

export const TEMP_ORDER = ["poco_caldo", "medio", "caldissimo", "perso"];

const STATUS_CATEGORY = {
  "Da assegnare": "unassigned",
  "Follow-up": "followup",
  "Mandare mail": "followup",
  "Nuovo lead": "new", "Da contattare": "active", "Primo tentativo": "active",
  "Non risponde": "warn", "Richiamare": "active", "Contattato": "active",
  "Interessato": "hot", "Appuntamento fissato": "hot", "Appuntamento effettuato": "hot",
  "No-show": "warn", "Preventivo inviato": "hot", "In trattativa": "hot",
  "Chiuso / Cliente": "won", "Non interessato": "lost", "Perso": "lost", "Numero errato": "lost",
};

export function statusClass(name) {
  const cat = STATUS_CATEGORY[name] || "active";
  return {
    new: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300 border-transparent",
    unassigned: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300 border-transparent font-semibold",
    followup: "bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300 border-transparent font-semibold",
    active: "bg-secondary text-secondary-foreground border-border",
    warn: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300 border-transparent",
    hot: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300 border-transparent",
    won: "bg-emerald-500 text-white border-transparent",
    lost: "bg-zinc-200 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400 border-transparent",
  }[cat];
}

export const CALL_OUTCOMES = [
  "Non risponde", "Occupato", "Richiamare", "Interessato", "Molto interessato",
  "Non interessato", "Appuntamento fissato", "Preventivo da inviare",
  "Sentirsi più avanti", "Numero errato", "Altro",
];

export const FOLLOWUP_OPTIONS = [
  { key: "later_today", label: "Più tardi oggi" },
  { key: "tomorrow", label: "Domani" },
  { key: "2days", label: "Tra 2 giorni" },
  { key: "3days", label: "Tra 3 giorni" },
  { key: "7days", label: "Tra 7 giorni" },
  { key: "next_week", label: "Settimana prossima" },
  { key: "custom", label: "Scegli data e ora" },
  { key: "none", label: "Nessun follow-up" },
];

export const APPT_MODES = ["Telefonico", "Videocall", "In presenza", "Altro"];
export const APPT_TYPES = ["Follow-up", "Primo contatto", "Fare check"];

// Telefono presente ma non utilizzabile (stessa regola del backend): es. "#ERROR!" importato dal foglio
export function isInvalidPhone(phone) {
  if (!phone) return false;
  const s = String(phone).trim();
  if (s.startsWith("#") || /[A-Za-z]/.test(s)) return true;
  const n = s.replace(/\D/g, "").length;
  return n < 8 || n > 15;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "dd/MM/yyyy", { locale: it }); } catch { return "—"; }
}
export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "dd/MM/yyyy · HH:mm", { locale: it }); } catch { return "—"; }
}
export function fmtTime(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "HH:mm", { locale: it }); } catch { return "—"; }
}
export function relDate(iso) {
  if (!iso) return "—";
  try {
    const d = parseISO(iso);
    if (isToday(d)) return `Oggi · ${format(d, "HH:mm")}`;
    if (isTomorrow(d)) return `Domani · ${format(d, "HH:mm")}`;
    if (isYesterday(d)) return `Ieri · ${format(d, "HH:mm")}`;
    return format(d, "dd/MM · HH:mm", { locale: it });
  } catch { return "—"; }
}
export function isOverdue(iso) {
  if (!iso) return false;
  try { return differenceInMinutes(new Date(), parseISO(iso)) > 0; } catch { return false; }
}

export function fullName(l) {
  if (!l) return "—";
  return `${l.first_name || ""} ${l.last_name || ""}`.trim();
}
export function fmtEuro(v) {
  if (v == null || v === "" || isNaN(Number(v))) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(v));
}
export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}
